import { useEffect } from "react";
import type { UseFormReturn } from "react-hook-form";
import type { FinalizeError } from "./useSubmitReservation";
import type { ReservationFormValues } from "../reservation-page.schema";

export function useFieldErrorMapper(
  submitError: FinalizeError | null,
  methods: UseFormReturn<ReservationFormValues>,
) {
  const setError = methods.setError;
  useEffect(() => {
    if (!submitError?.perFieldErrors) return;
    for (const [ticketIdStr, fieldErrors] of Object.entries(submitError.perFieldErrors)) {
      const ticketId = parseInt(ticketIdStr);
      for (const [attributeId, message] of Object.entries(fieldErrors)) {
        const path = `ticketPersonData.${ticketId}.${attributeId}`;
        setError(path as any, { message });
      }
    }
  }, [submitError, setError]);
}